import React from 'react';
import ReactMarkdown from 'react-markdown';

import { Messages } from '../../../codegen/Localize';
import { WelcomeChannelStateProps } from '../../../home/components/WelcomeChannel';
import { WelcomeChannelStyles } from '../../../home/styles/WelcomeChannelStyles';
import { htmlToMarkdown } from '../utils/MarkdownHtml';
import { WelcomeChannelCloseButton } from './WelcomeChannelCloseButton';
import { WelcomeChannelPreview } from './WelcomeChannelPreview';

export interface PreviewProps {
  showDefaultWelcomeChannel: boolean;
  html: string;
  welcomeChannelProps: WelcomeChannelStateProps;
}

export class Preview extends React.PureComponent<PreviewProps> {
  private allowedTypes: ReactMarkdown.NodeType[] = ['root', 'text', 'paragraph', 'link'];

  render() {
    const markdown = htmlToMarkdown(this.props.html);

    const footerCloseButton =
      <WelcomeChannelCloseButton
        handleClick={() => {}}
        tooltipText={Messages.settings_welcomeChannel_dismiss_tooltip()}
        disabled={true}
        footerOnly={true}
      />;

    const footer =
      <div className={WelcomeChannelStyles.footer} data-tb-test-id={'server-footer-preview'} >
        <ReactMarkdown source={markdown} escapeHtml={true} allowedTypes={this.allowedTypes} linkTarget={'_blank'} />
        {!this.props.showDefaultWelcomeChannel && footerCloseButton}
      </div>;

    return (
      <div>
        {this.props.showDefaultWelcomeChannel && <WelcomeChannelPreview {...this.props.welcomeChannelProps} />}
        {this.props.html && footer}
      </div>
    );
  }
}
